document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector("#yotpo-widget__js")) {
    const yotpoClick = function (elm) {
      elm
        .closest(".yotpo-review")
        .querySelector(".yotpo-comments-box")
        .setAttribute("style", "display: block !important;");
    };
    var yotpoCheck = setInterval(function () {
      if (document.querySelector(".lalo-yotpo__content .yotpo-reviews")) {
        const yotpoClkElm = document.querySelector(
          ".lalo-yotpo__content .yotpo-reviews"
        );
        yotpoClkElm.querySelectorAll(".yotpo-review").forEach((elm) => {
          if (elm.querySelector(".yotpo-comments-box")) {
            elm
              .querySelector(".yotpo-comments-box")
              .style.removeProperty("display");
            elm
              .querySelector(".yotpo-comments-box")
              .style.setProperty("display", "none");
          }
        });
        clearInterval(yotpoCheck);
      } else {
        //console.log('no')
      }
    }, 100);
  }
});
